import { Link } from "react-router-dom";
import { Waves } from "lucide-react";
import AdStrip from "@/components/AdStrip";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-white mt-24" data-testid="site-footer">
      <AdStrip placement="footer" />
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <span className="grid place-items-center h-9 w-9 rounded-md bg-secondary text-secondary-foreground">
              <Waves className="h-5 w-5" strokeWidth={2.4} />
            </span>
            <span className="font-display font-black tracking-tight text-lg">
              Docto<span className="text-primary">Spa</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-md leading-relaxed">
            Le diagnostic technique de votre spa en 2 minutes. Détectez les pannes,
            obtenez des recommandations claires, et prolongez la durée de vie de votre équipement.
          </p>
        </div>
        <div>
          <div className="eyebrow mb-4">Produit</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/diagnostic" className="hover:text-primary">Diagnostic</Link></li>
            <li><Link to="/technicians" className="hover:text-primary">Annuaire</Link></li>
            <li><Link to="/annuaire-fabricants" className="hover:text-primary">Fabricants</Link></li>
            <li><Link to="/pieces-detachees" className="hover:text-primary">Pièces détachées</Link></li>
            <li><Link to="/codes-erreurs" className="hover:text-primary">Codes erreurs</Link></li>
            <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
            <li><Link to="/pricing" className="hover:text-primary">Tarifs</Link></li>
            <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Entreprise</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-primary">À propos</Link></li>
            <li><Link to="/installations" className="hover:text-primary">Nos installations</Link></li>
            <li><Link to="/contact" className="hover:text-primary">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5 py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} DoctoSpa. Tous droits réservés.
      </div>
    </footer>
  );
}
